import React from 'react';
import Head from 'next/head';
import { useRouter } from 'next/router';
import { ApolloProvider, NormalizedCacheObject } from '@apollo/client';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import SnackbarProvider from 'react-simple-snackbar';

import { AppConfigContextProvider } from '@edx/contexts/app-config';
import { ThemeContextProvider } from '@edx/contexts/theme';
import { useApollo } from '@edx/helpers/apollo';
import { NavbarVariantProps } from '@edx/components/navbar';
import { FooterColumn } from '@edx/components/footer';
import { NavbarLinkProps } from '@edx/components/navbar/components/navbar-link/navbar-link';

import { Page } from './components';

type Props = {
  initialApolloState: NormalizedCacheObject;
  navBarLinks: NavbarLinkProps[];
  projectName: string;
  projectShortName: string;
  email: string;
  footerColumns: FooterColumn[];
  simpleFooter: boolean;
  navBar: NavbarVariantProps;
  faviconColor: string;
  simpleNavBar: boolean;
};

export const AppFrame: React.FC<Props> = ({
  initialApolloState,
  navBarLinks,
  projectName,
  projectShortName,
  email,
  footerColumns,
  simpleFooter,
  navBar = { position: 'static', variant: 'solid' },
  simpleNavBar,
  faviconColor,
  children,
}) => {
  const apolloClient = useApollo(initialApolloState);
  const router = useRouter();

  return (
    <AppConfigContextProvider value={{ projectName, projectShortName, email }}>
      <ThemeContextProvider value={{ navBar }}>
        <ApolloProvider client={apolloClient}>
          <SnackbarProvider>
            <Head>
              <link rel="apple-touch-icon" sizes="180x180" href="/favicons/apple-touch-icon.png" />
              <link rel="icon" type="image/png" sizes="32x32" href="/favicons/favicon-32x32.png" />
              <link rel="icon" type="image/png" sizes="16x16" href="/favicons/favicon-16x16.png" />
              <link rel="manifest" href="/favicons/site.webmanifest" />
              <link rel="mask-icon" href="/favicons/safari-pinned-tab.svg" color={faviconColor} />
              <link rel="shortcut icon" href="/favicons/favicon.ico" />
              <meta name="msapplication-TileColor" content={faviconColor} />
              <meta name="msapplication-config" content="/favicons/browserconfig.xml" />
              <meta name="theme-color" content={faviconColor} />
            </Head>

            <Page
              children={children}
              navBarLinks={navBarLinks}
              simpleNavBar={simpleNavBar || router.query?.nav === 'f'}
              footerColumns={footerColumns}
              simpleFooter={simpleFooter}
            />
          </SnackbarProvider>
        </ApolloProvider>
      </ThemeContextProvider>
    </AppConfigContextProvider>
  );
};
